/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { parse, stringify } from 'zipson';
import { Names } from './storeName';

// 用户/会员相关信息管理
export const useStore = defineStore(Names.USER, {
  state: () => ({
    isShowVipCenter: false, // 是否展示会员弹窗
    isLogin: false, // 是否登录
    isSvip: false, // 是否超级会员
    svipSource: '', // 订单埋点
    isSlideVip: false, // 是否PPT会员
    isShowWithMorePackage: false, // 是否展示会员加量包
    isShowSlidePackage: false, // 是否展示ppt加量包
    isShowVipWindow: false, // 是否展示会员弹窗组件
    morePackageTypeIndex: null, // 会员加量包类型
    isVip: false, // 是否词典会员
    showLoginPanel: false, // 是否展示登录弹窗
    isOutlineSync: false, // 大纲是否已同步完成
    isSlideSync: false, // PPT 是否已同步完成
    isFetchLogin: false, // 登录接口是否已更新
  }),

  persist: {
    key: 'yd_ai_ppt_store_user',
    storage: sessionStorage,
    paths: [
      'isLogin',
      'isOutlineSync',
      'isSlideSync',
    ],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },

  getters: {
    getShowVip: (state) => state.isShowVipCenter,
    getLogin: (state) => state.isLogin,
    getSvip: (state) => state.isSvip,
    getSvipSource: (state) => state.svipSource,
    getSlideVip: (state) => state.isSlideVip,
    getShowPackage: (state) => state.isShowWithMorePackage,
    getShowSlidePackage: (state) => state.isShowSlidePackage,
    getShowVipWindow: (state) => state.isShowVipWindow,
    getMorePackageTypeIndex: (state) => state.morePackageTypeIndex,
    getVip: (state) => state.isVip,
    getShowLoginPanel: (state) => state.showLoginPanel,
    getOutlineSyncStatus: (state) => state.isOutlineSync,
    getSlideSyncStatus: (state) => state.isSlideSync,
    getFetchLogin: (state) => state.isFetchLogin,
  },

  actions: {
    changeVipShow(value) {
      this.isShowVipCenter = value;
    },
    changeLogin(value) {
      this.isLogin = value;
    },
    changeSvip(value) {
      this.isSvip = value;
    },
    changeSvipSource(value) {
      this.svipSource = value;
    },
    changeSlideVip(value) {
      this.isSlideVip = value;
    },
    changeShowPackage(value) {
      this.isShowWithMorePackage = value;
    },
    changeShowSlidePackage(value) {
      this.isShowSlidePackage = value;
    },
    changeShowVipWindow(value) {
      this.isShowVipWindow = value;
    },
    changeMorePackageTypeIndex(value) {
      this.morePackageTypeIndex = value;
    },
    changeVip(value) {
      this.isVip = value;
    },
    changeShowLoginPanel(value) {
      this.showLoginPanel = value;
    },
    changeOutlineSyncStatus(value) {
      this.isOutlineSync = value;
    },
    changeSlideSyncStatus(value) {
      this.isSlideSync = value;
    },
    changeFetchLogin(value) {
      this.isFetchLogin = value;
    },
  },
})
